<template>
    <app-modal :modal-id="modalId" :modal-size="modalSize" :modal-alignment="modalAlignment" :modal-scroll="false"
        :modal-body-class="'w-full max-w-full wizard-steps'" @close-modal="closeModal">
	
        <template slot="header">
            <h5 class="modal-title">
                {{ modalTitle }}
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close"
                @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
		<app-overlay-loader v-if="preloader" />
		<template slot="body">
            <div class="form-group row align-items-center">
                <label for="inputs_code" class="col-md-2 mb-0" style="font-size: 15px;">
                    Note
                </label>
                <div class="col-md-9">
                    <app-input id="user_address"
                                type="textarea"
                                v-model="inputs.note"
                                :placeholder="'Enter your note...'"/>
                </div>
            </div>
		</template>
		
		<template slot="footer">
			<button class="btn btn-success" type="button" :disabled="loadingSubmit" @click.prevent="submitMove">
				<span v-if="loadingSubmit" class="w-100">
					<span class="spinner-bounce">
						<span class="bounce1 mr-1"/>
						<span class="bounce2 mr-1"/>
						<span class="bounce3 mr-1"/>
					</span>
				</span>
				<template v-else>Submit</template>
			</button>&nbsp;
			<button class="btn btn-secondary" type="button" @click.prevent="closeModal">
				Close
			</button>
		</template>
    </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";


export default {
	name: "ModalMove",
	mixins: [FormMixin, ModalMixin],
	props: {
		modalId: String,
		inputs: {
			type: Object,
			default: () => {
				return {
                    lead_id : null,
                    course_id : null,
                    status : 2,
                    note: null
				};
			},
		},
	},
	data() {
		return {
			modalIdMove:'modal-move',
            loadingSubmit: false,
			preloader: false,
			formData:{},
            modalSize: 'large',
            modalAlignment: 'center',
		};
	},
    computed: {
        modalTitle() {
            return `Move`;
        }
    },
	created() {
	},
	methods: {

        closeModal() {
            this.$emit('close-modal');
        },
        submitMove(){
            this.loadingSubmit = true;
            this.preloader = true;
            this.inputs.status = 2;
            this.axiosPatch({
                url: `/transaction/move-student-by-teacher`,
                data: this.inputs
            })
            .then((response) => {
                Swal.close();
                
                this.loadingSubmit = false;
                this.preloader = false;

                if (response.data.status === true) {
                    this.$emit('close-modal');
                    Swal.fire({
                        title: "Success",
                        text: "",
                        icon: "success",
                    }).then(() => {
                    });
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: response.data.message,
                        icon: "error",
                    });
                }
            })
            .catch((error) => {
                this.loadingSubmit = false;
                this.preloader = false;
                Swal.close();

                const message = error.response?.data?.message || error.message || "Something went wrong";

                Swal.fire({
                    title: "Failed",
                    text: message,
                    icon: "error",
                });
            });
        }
	},
};
</script>

<style scoped>
    ::v-deep .modal-content {
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35) !important;
        border-radius: 12px !important;
    }
</style>